import { useCallback, useState } from 'react'

/**
 * Un booleano que sobrevive al reload.
 *
 * Es para preferencias de layout que la persona ya decidió una vez — la
 * swimlane de permanentes colapsada, por ejemplo. Todo va dentro de `try`:
 * en modo privado `localStorage` existe pero tira al escribir, y una pantalla
 * entera no se puede caer por no poder recordar un acordeón.
 */
export function usePersistedFlag(key: string, fallback: boolean) {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(key)
      return stored === null ? fallback : stored === '1'
    } catch {
      return fallback
    }
  })

  const update = useCallback(
    (next: boolean) => {
      setValue(next)
      try {
        localStorage.setItem(key, next ? '1' : '0')
      } catch {
        /* sin persistencia: la sesión igual funciona */
      }
    },
    [key],
  )

  const toggle = useCallback(() => update(!value), [update, value])

  return [value, update, toggle] as const
}
